import BaseRepository from "@/services/resources/repository";
import queryByKeys from "@/services/resources/mixins/query-by-keys";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(queryByKeys);
    }

    getBySlugWithServices(slug) {
        const name = slug.replaceAll('-', ' ');

        return this.transformer.one(
            this.try(
                this.baseQuery()
                    .where('name', name)
                    .include('service-service-categories.services')
                    .first()
            )
        );
    }

    byLookupWithServicesAndModules(lookup) {
        return this.transformer.one(
            this.try(
                this.baseQuery()
                    .where('lookupKey', lookup)
                    .include('service-service-categories.services.service-modules.modules.modules')
                    .first()
            )
        );
    }
}

export default Repository;
